import { useMediaQuery } from "@vueuse/core";

export function useIsScreenLarge() {
  const isScreenLarge = useMediaQuery("(min-width: 1024px)");

  return { isScreenLarge };
}
